export default "__VITE_ASSET__d684ddf3__"